import { makeStyles } from "@mui/styles";
import { DataGridPro } from "@mui/x-data-grid-pro";
import React, { useEffect } from "react";
import { SENIORITY_LIST_PAGE_TYPE } from "../util/constants";
import { getColumns } from "../util/seniorityListUtils";
import CustomErrorTableOverlay from "./CustomErrorTableOverlay";
import customLoadingTableOverlay from "./CustomLoadingTableOverlay";
import CustomNoRowsTableOverlay from "./CustomNoRowsTableOverlay";

const useStyles = makeStyles((theme) => ({
  collisionRow: {
    backgroundColor: theme.palette.secondary.swaLightRed + " !important",
  },
  seniorityListTable: (props) => ({
    "& div": {
      "& .MuiDataGrid-footerContainer": {
        display: "none",
      },
    },
    borderRadius: "0px",
  }),
  evenRow: {
    backgroundColor: theme.palette.secondary.swaGray1,
  },
  tempChip: {
    marginLeft: "5px",
  },
}));

const SeniorityListItem = (props) => {
  const classes = useStyles();
  const [sortModel, setSortModel] = React.useState([
    {
      field: "rank",
      sort: "asc",
    },
  ]);

  useEffect(() => {
    setSortModel([
      {
        field: "rank",
        sort: "asc",
      },
    ]);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.seniorityList]);

  return (
    <div style={{ width: "100%", height: "inherit" }}>
      <DataGridPro
        className={classes.seniorityListTable}
        rows={props.seniorityList}
        apiRef={props.apiRef}
        columns={getColumns(props)}
        rowKeyGetter={(row) => row.rank}
        getRowId={(row) => row.rank}
        getRowClassName={(row) => {
          return `${row.row.isSeniorityCollision && !row.row.seniorityTiebreakerDate ? classes.collisionRow : ""} ${
            row.indexRelativeToCurrentPage % 2 === 0 ? classes.evenRow : ""
          }`;
        }}
        disableColumnMenu={true}
        sortModel={sortModel}
        onSortModelChange={(event) => {
          setSortModel(event);
        }}
        rowHeight={50}
        components={{
          LoadingOverlay: customLoadingTableOverlay,
          NoRowsOverlay: CustomNoRowsTableOverlay,
          ErrorOverlay: CustomErrorTableOverlay,
        }}
        componentsProps={{
          noRowsOverlay: {
            pageType: SENIORITY_LIST_PAGE_TYPE,
            isEmployeeView: props.isEmployeeView,
            seniorityListFtPtCount: props.seniorityListFtPtCount,
          },
          errorOverlay: {
            errorMessage: props.errorObject.message,
            errorCode: props.errorObject.code,
          },
        }}
        loading={props.isLoading}
        error={props.isError}
        ref={props.gridRef}
      />
    </div>
  );
};

export default SeniorityListItem;
